export const PRIMARY_AGGREGATION_SETTING = 'PRIMARY_AGGREGATION';
export const SECONDARY_AGGREGATION_SETTING = 'SECONDARY_AGGREGATION';